<template>
  <div class="checkout-appbar">
    <v-container class="px-sm-12 px-md-3 py-0 checkout-appbar__container">
      <header class="pa-0 mx-md-5 checkout-appbar__content">
        <nuxt-link
          style="position: absolute; left: 0"
          :to="localePath('/')"
          class="text-body-3 text-decoration-none grey-darken-4--text"
        >
          <base-icon mdi="chevron-left"></base-icon>
          {{ $t('actions.back') }}
        </nuxt-link>
        <div
          class="mx-auto checkout-appbar__logo"
          :class="{ 'checkout-appbar__logo--small': $i18n.locale === 'fr-FR' }"
        >
          <app-bar-logo></app-bar-logo>
        </div>
      </header>
    </v-container>
  </div>
</template>

<script>
import AppBarLogo from '~/components/app-bar/AppBarLogo'
import BaseIcon from '~/components/base/icon/BaseIcon'
export default {
  name: 'CheckoutAppbar',
  components: { BaseIcon, AppBarLogo },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.checkout-appbar {
  margin-bottom: 100px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-bottom: 72px;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-bottom: 50px;
  }

  &__container {
    position: fixed;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 1;
  }

  &__content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      height: 72px;
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: 50px;
    }
  }
  &__logo {
    svg {
      width: 139px;

      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        width: 123px;
      }
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
      &--small {
        svg {
          width: 100px;
        }
      }
    }
  }
}
</style>
